import { render, staticRenderFns } from "./ActionsForm.vue?vue&type=template&id=b120757e&scoped=true&"
import script from "./ActionsForm.vue?vue&type=script&lang=js&"
export * from "./ActionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b120757e",
  null
  
)

export default component.exports